"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityViewModel = void 0;
const FlowNodeViewModel_1 = require("../FlowNodeViewModel");
class ActivityViewModel extends FlowNodeViewModel_1.FlowNodeViewModel {
}
exports.ActivityViewModel = ActivityViewModel;
//# sourceMappingURL=ActivityViewModel.js.map